import { slideright, slide } from '../../transitions';

const Routes = () => {
	return (
		['/search', '/', '/favourites', '/error', '/impressum']
	)
};

const Swiped = {
  left: 'left',
  right: 'right',
  up: 'up',
  down: 'down',
  none: 'none'
};

let currentRoute = 1;
let stack = [];


const Navigationstack = (history, direction) => {	
	let transition = slide;
	let to = Routes()[1];

	switch(direction) {
      case Swiped.left:
      	if (currentRoute < Routes.length - 1) currentRoute++;
      break
      case Swiped.right:
      	if (currentRoute > 0) currentRoute--;
        transition = slideright;
      break
      default:
        console.log("What a Swipe... :P");
      break
    }

    to = Routes[currentRoute];
	if (history.location.pathname !== to) {
		history.push({ pathname: to, state: transition });
		stack.push(to);
		sessionStorage.setItem('stack', stack);
	}
	return;
};

const RouteTo = (history, path, transition, exact = false, content = '') => {
	//document.body.scrollTop = 0;

	const last = history.location.pathname;
	let present = transition;

	if (last !== path) {
		if (exact && last !== Routes()[0] && present.transition !== "fade") { // Check Transision Type [left | right]
			present = slideright;
		}

		currentRoute = Routes().indexOf(path); // for Swipe enabled PWA

		stack.push(path);
		sessionStorage.setItem('stack', stack);
		history.push({ pathname: path, state: present, 'content': content});
	}
	return;
};

const Back = (history) => {
	let sess = sessionStorage.getItem('stack').split(',');
	let previous = sess[sess.length - 2];
	
	sess.pop();
	stack = sess;
	sessionStorage.setItem('stack', sess);

	if (!previous) previous = '/';
	history.push({ pathname: previous, state: slideright });
}

const BackToRoot = (history) => {
	let routes = Routes();
	let navstack = sessionStorage.getItem('stack').split(',').reverse();

	for (var i = 0; i < navstack.length; i++) {
		if (routes.includes(navstack[i])) {
			stack = [];
			history.push({ pathname: navstack[i], state: slideright });
			stack.push(navstack[i]);
			sessionStorage.setItem('stack', stack);
			return;
		}
	}
	
	// Fallback after reloading page
	history.push({ pathname: '/', state: slideright });
	stack = [];
	stack.push('/');
	sessionStorage.setItem('stack', '/');
}

export { Navigationstack, Swiped, RouteTo, BackToRoot, Back, Routes };
